import * as React from "react";
const SvgFiRrDrawerAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drawer-alt_svg__a)">
      <path
        fill="#062147"
        d="m23.005 19-.375-.002h-.011c-.998 0-1.994-.12-2.961-.36l-.901-.224a14.4 14.4 0 0 0-3.443-.419h-.013l-4.66.005h-.003c-.8 0-1.494-.535-1.614-1.245A1.515 1.515 0 0 1 10.238 15h5.763a1 1 0 1 0 0-2h-1.002l4.932-5.487 2.747 1.211a.942.942 0 0 0 .774-1.718l-2.18-1.002a3.05 3.05 0 0 0-.166-4.12c-1.192-1.192-3.131-1.192-4.368.047l-1.591 1.812-7.189 2.8a10 10 0 0 0-4.122 3L.513 13.618a2.34 2.34 0 0 0 .186 3.131c.005.005.011.004.016.008.183.201.44.332.734.332a1 1 0 0 0 1-1 .99.99 0 0 0-.365-.756l.018-.01a.34.34 0 0 1-.039-.443l3.695-4.532a6 6 0 0 1 2.398-1.77l4.259-1.726L3.242 17.3A5 5 0 0 0 2 20.6V22a1 1 0 0 0 1 1h1.054a4.99 4.99 0 0 0 3.816-1.77l1.305-1.542c.452.194.944.311 1.461.311h.006l4.66-.005q1.517 0 2.973.36l.901.224a14.4 14.4 0 0 0 3.436.42h.013l.369.001h.005a1 1 0 0 0 .005-2zm-4.81-15.702a1.06 1.06 0 0 1 1.495 0c.412.412.412 1.083-.037 1.534L12.308 13s-2.246.003-2.293.01c-.152.022-.296.068-.442.11zM6.344 19.938A3 3 0 0 1 4.054 21H4v-.402c0-.729.265-1.432.746-1.979l2.306-2.626a3.5 3.5 0 0 0 0 1.097 3.3 3.3 0 0 0 .568 1.343L6.345 19.94z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drawer-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrawerAlt;
